export const SOL_DECIMALS = 9;
export const SOLANA_COIN_ID = 501;

export const SOLANA_MAINNET_CAIP2_ID = 'solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp';
export const SOLANA_DEVNET_CAIP2_ID = 'solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1';
export const SOLANA_TESTNET_CAIP2_ID = 'solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z';

export const RPC_URL_PROXY_API_ENDPOINT = '/proxy/nownodes/sol';
export const RPC_URL_DEVNET = 'https://api.devnet.solana.com';
export const RPC_URL_TESTNET = 'https://api.testnet.solana.com';

export const BLOCKAID_API_KEY = 'DUMMY_API_KEY'; // since we're using our own proxy and api key is handled there, we can use a dummy key here
